module.exports = __webpack_public_path__ + "static/media/logo.0d7eb77d.png";